import { css } from 'lit';

export const appFooterStyles = css`
  :host {
    display: block;
    margin-top: 3rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border-color, #e5e5de);
    font-family: var(--font-mono, monospace);
    font-size: 0.8rem;
    color: var(--text-muted, #7c7c75);
  }

  .site-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .footer-meta {
    color: var(--text-muted, #7c7c75);
  }

  a {
    color: var(--text-muted, #7c7c75);
    text-decoration: none;
  }

  a:hover {
    color: var(--accent-color, #245590);
  }
`;
